import ENV from 'lumen/config/environment';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function getEnv(key: keyof typeof ENV) {
  return ENV[key];
}
